import { combineReducers } from 'redux';
import { merge } from 'lodash'
import { normalize, schema } from 'normalizr';

// Define a itemmaps schema
const itemmapSchema = new schema.Entity('itemmaps', {}, { idAttribute: 'id' });
const itemmapListSchema = [itemmapSchema];

const defaultItemmapParams = {
  itemmapFetched: false,
  searchFetched: false,
  isDelFetched: false,
  createTitle: 'Create a New Item Mapping',
  createSubmitButtonText: 'Create Mapping',
  editTitle: 'Edit Item Mapping',
  editSubmitButtonText: 'Edit Mapping',
  cloneTitle: 'Clone Item Mapping',
  cloneSubmitButtonText: 'Clone Mapping'
}


function byId(state = {}, action) {
  if (action.type === 'SAVED_ITEMMAP') {
    const itemmapID = action.payload.id;
    if (action.txn === "success") {
      return {
        ...state,
        [itemmapID]: action.payload
      }
    } else {
      return state
    }

  }
  if (action.type === 'FETCHED_ITEMMAP') {
    const normalizedItemmap = normalize(action.payload, itemmapListSchema);
    return merge({}, state, normalizedItemmap.entities.itemmaps)
  }
  if (action.type === 'DELETED_ITEMMAP') {
    if (action.payload.msg === "Success") {
      const itemmapID = action.payload.id;
      return {
        ...state,
        [itemmapID]: {
          ...state[itemmapID],
          status: 0
        }
      }
    } else {
      return state
    }
  }
  if (action.type === 'RESET_DATA') {
    return {}
  } else {
    return state
  }
}

function searchResults(state = {}, action) {
  if (action.type === 'STORE_SEARCH_ITEMMAP_RESULT') {
    const normalizedItemmap = normalize(action.payload, itemmapListSchema);
    return merge({}, normalizedItemmap.entities.itemmaps)
  } else {
    return state
  }
}

function filterResults(state = {}, action) {
  if (action.type === 'FILTER_ITEMS') {
    const col = action.payload.col;
    return {
      ...state,
      [col]: action.payload
    }
  } else {
    return state
  }
}

function notifications(state = {}, action) {
  if (action.type === 'SAVED_ITEMMAP') {

    return {
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        save: {
          status: (action.txn === "success" || action.txn === "Success") ? 'success' : 'error',
          msg: action.msg ? action.msg : (action.txn === "success" || action.txn === "Success") ? 'success' : 'error'
        }
      }
    }
  }
  if (action.type === 'DELETED_ITEMMAP') {
    return {
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        delete: {
          status: action.payload.msg === "Success" ? 'success' : 'error',
          msg: action.payload.msg
        }
      }
    }
  }
  if (action.type === 'NOTIFICATION_DONE_ITEMMAP') {
    const { id, type } = action.payload
    // Remove the 'id' element from state
    const { [id]: idValue, ...restOfState } = state;
    // Remove the 'type' from the 'id' element
    const { [type]: removedValue, ...restOfId } = idValue;
    // Merge back together
    const finalState = { ...restOfState, [id]: restOfId };
    return finalState

  } else {
    return state
  }
}


function params(state = defaultItemmapParams, action) {
  if (action.type === 'FETCHED_ITEMMAP') {
    return {
      ...state,
      itemmapFetched: true,
      isFetching: false
    }
  } if (action.type === 'SEARCH_ITEMMAP') {
    return {
      ...state,
      searchFetched: false,
      isSearching: true,
    }
  }
  if (action.type === 'STORE_SEARCH_ITEMMAP_RESULT') {
    return {
      ...state,
      searchFetched: true,
      isSearching: false,
    }
  }
  if (action.type === 'DELETED_ITEMMAP') {
    return {
      ...state,
      isDelFetched: true
    }
  } if (action.type === 'SET_ITEMMAP_FETCH_OFF') {
    return {
      ...state,
      isDelFetched: false
    }
  }
  if (action.type === 'RESET_DATA') {
    return defaultItemmapParams
  } else {
    return state
  }
}

const itemmap = combineReducers({
  byId,
  notifications,
  searchResults,
  params,
  filterResults
});

export default itemmap;

